﻿namespace WebPortal.Dialog.Modal {
    export enum TMessageOption { mo_asText, mo_asPopup }

    const cMessage_Category_Published = 'Published';
    const cMessage_Category_ToPublish = 'ToPublish';
    const cMessage_Category_ToDelete = 'ToDelete';

    export class NotificationCenter {
        constructor() {
            this.init();
        }

        private init(): void {
            if (navigationUtils.isButtonDisabled("Notification")) {
                navigationUtils.disableButton("Notification");
                navigationUtils.addCounter("Notification", 0);
            } else {
                $("#lbt_notification_center").off().on("click", () => {
                    return this.NotificationCenterClick();
                });
            }
        }

        private NotificationCenterClick(): Boolean {
            let MessageFound = false;
            $("#pn_notification_center_popup_body").empty();

            // Alle To Publish Elemente ausgeben
            if (!!MessageProviderObj && !!MessageProviderObj.ToPublish && (MessageProviderObj.ToPublish.length > 0)) {
                this.AddListToNotificationCenter(MessageProviderObj.ToPublish);
                MessageFound = true;
            }
            // Alle Puslished Elemente ausgeben
            if (!!MessageProviderObj && !!MessageProviderObj.Published && (MessageProviderObj.Published.length > 0)) {
                this.AddListToNotificationCenter(MessageProviderObj.Published);
                MessageFound = true;
            }

            if (!MessageFound) {
                $("#pn_notification_center_popup_body").append(
                    $("<div>")
                        .attr({
                            "class": "alert alert-info",
                            "role": "alert"
                        }).text("No active Notification")
                );
            }

            $("#pn_notification_center_popup").modal({ backdrop: "static", keyboard: false });
            return false;
        }

        private AddListToNotificationCenter(_List: any): void {
            for (let key in _List) {
                if (_List.hasOwnProperty(key)) {
                    $("#pn_notification_center_popup_body")
                        .append(
                        $("<div>")
                            .attr({
                                "class": "panel panel-default",
                            })
                            .append(
                            $("<div>")
                                .attr({
                                    "class": "panel-heading",
                                })
                                .append(
                                $("<h3>")
                                    .attr({
                                        "class": "panel-title",
                                    }).text(_List[key].Title))
                            )
                            .append(
                            $("<div>")
                                .attr({
                                    "class": "panel-body",
                                }).append(_List[key].Message)
                            )
                        );
                }
            }
        }

        public PrepareNotificationCenter(): void {
            let Count: number = 0;
            if (!!MessageProviderObj && !!MessageProviderObj.ToPublish && (MessageProviderObj.ToPublish.length > 0)) {
                Count += MessageProviderObj.ToPublish.length;
            }
            // Alle Puslished Elemente ausgeben
            if (!!MessageProviderObj && !!MessageProviderObj.Published && (MessageProviderObj.Published.length > 0)) {
                Count += MessageProviderObj.Published.length;
            }
            if (Count == 0) {
                navigationUtils.disableButton("Notification");
            } else {
                navigationUtils.enableButton("Notification", () => { return this.NotificationCenterClick(); });
            }
            navigationUtils.addCounter("Notification", Count);
        }
    }

    export class Notification {
        constructor() {
            this.init();
        }

        private init(): void {
            // Close (Confirm) Popup Handler setzen
            $("#bt_notification_popup_close").off().on("click", () => {
                return this.ConfirmNotifcation();
            }).on('keyup', (e: JQueryEventObject) => {
                let ev: any = e || event;
                if (ev.keyCode === 13) {
                    return this.ConfirmNotifcation();
                }
            });

            $("#bt_notification_popup_close_x").off().on("click", () => {
                return this.ConfirmNotifcation();
            });
        }


        private ConfirmNotifcation(): boolean {
            $("#pn_notification_popup").modal("hide");

            let requestParam: string = $("#hdf_se_request_param").val();
            let Message_ID: number = $("#hdf_notification_popup_message_id").val();
            let MessageType: number = $("#hdf_notification_popup_messagetype").val();
            if (!!requestParam && !!Message_ID && !!MessageType) {
                WebPortalHubObj.server.doConfirmMessageOnMessageProvider(requestParam, Message_ID, MessageType);
                console.info("Notification - Confirm Popup!");
            } else {
                console.error("Notification - Confirm Popup - Parameter Error!");
            }
            return false;
        }

        public showNotifcationPopup(): void {
            let newNotificationToShow: boolean = false;
            let toPublishList: any = MessageProviderObj.ToPublish;

            if (ShowPopupNotification && !!toPublishList && (toPublishList.length > 0)) {
                for (let key in toPublishList) {
                    if (toPublishList.hasOwnProperty(key)) {
                        if ((<TMessageOption>toPublishList[key].MessageOption) == TMessageOption.mo_asPopup) {
                            $("#hdf_notification_popup_message_id").val(toPublishList[key].Message_ID);
                            $("#hdf_notification_popup_messagetype").val(toPublishList[key].MessageType);
                            $("#lb_notification_popup_title").html(toPublishList[key].Title);
                            $("#pn_notification_popup_body").html(toPublishList[key].Message);
                            $("#pn_notification_popup").modal({ backdrop: "static", keyboard: false });
                            newNotificationToShow = true;
                            break;
                        }
                    }
                }
            }

            if ((!newNotificationToShow) && $('#pn_notification_popup').hasClass('in')) {
                $("#pn_notification_popup").modal("hide");
            }            
        }

    }

}